import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import useConfirmation from "../../../hooks/ConfirmationDialog";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import Button from "../../../ui_components/Button/Button";
import RemoveDeliveryPersonInfoButtonProperties from './RemoveDeliveryPersonInfoButtonProperties';
import IconName from '../../../ui_components/Icon/enums/IconName';
import Icon from '../../../ui_components/Icon/Icon';

const RemoveDeliveryPersonInfoButton: React.FC<RemoveDeliveryPersonInfoButtonProperties> = ({
                                                                                  onClick = () => {},
                                                                                  onSave = () => {},
                                                                                  showIcon = true,
                                                                                  showText = true,
                                                                                  disabled,
                                                                                  className = '',
                                                                                  deliveryPersonInfo,
                                                                                  onRemoveDeliveryPersonInfo,
                                                                                  rounded = false,
                                                                                  size = ButtonSize.DEFAULT,
                                                                                  type = ButtonType.DEFAULT
}) => {

    const i18n = useI18nContext();
    const confirm = useConfirmation();

    const handleOnclick = async () => {
        const success = await confirm(i18n.translate("REMOVE_DELIVERY_PERSON_INFO_CONFIRMATION"), '');
        if(success){
            onRemoveDeliveryPersonInfo(deliveryPersonInfo)
        }       
    }

    const text = i18n.translate("REMOVE_DELIVERY_PERSON_INFO");

    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                size={size}
                type={type}
                icon={showIcon ? <Icon name={IconName.DELETE_ICON}/> : <></>}
            />
        }
        return <Button
            onClick={handleOnclick}
            className={className}
            disabled={disabled}
            tooltip={!showText ? text : ""}
            text={showText ? text : ""}
            size={size}
            type={type}
            startIcon={showIcon ? <Icon name={IconName.DELETE_ICON}/> : <></>}
        />
    }

    return <Observer>
        {() => (
            <Btn/>
        )}
    </Observer>
}

export default RemoveDeliveryPersonInfoButton;
